module.exports = {
	"name": "@bingads-webui/primitive-utilities",
	"description": "Please find documentation and tutorial at http://internal-bingadsresources-westus.cloudapp.net/jsdoc/primitive-utilities/index.html",
	"version": "1.5.1",
	"main": "dist/index",
	"license": "UNLICENSED",
	"peerDependencies": {
		"underscore": "^1.8.3",
		"backbone": "^1.3.3"
	},
	"devDependencies": {
		"underscore": "1.8.3",
		"backbone": "1.3.3",
		"chai": "3.5.0",
		"jquery": "3.1.1"
	}
};


//////////////////
// WEBPACK FOOTER
// ./packages/primitive-utilities/package.json
// module id = 766
// module chunks = 41